/* N1 · Giga Grip: el dato oficial es 4 mm de látex + 3 mm de espuma interna.
   Donde el nombre aparece suelto (escala de palmas, menú por palma, centro de ayuda),
   se completa con el grosor, como el resto de palmas. */
(function(){
if(window.N1PalmFix)return;window.N1PalmFix=1;
var RE=/Giga Grip(?!\s*[\u00b7\u2013-]\s*4)/g, TO='Giga Grip \u00b7 4 mm';
var SCOPE='.n1-latex, .n1-compare, #n1k-cpop, .n1g, .n1a-content, .n1a-main, .n1tp';
function walk(root){
  var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null),n,list=[];
  while((n=w.nextNode()))list.push(n);
  list.forEach(function(node){
    var p=node.parentNode;if(!p||/SCRIPT|STYLE|A/.test(p.tagName))return;
    var v=node.nodeValue;if(!v||v.indexOf('Giga Grip')<0)return;
    var out=v.replace(RE,TO);
    if(out!==v)node.nodeValue=out;
  });
}
function run(){document.querySelectorAll(SCOPE).forEach(walk)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
addEventListener('load',run);setTimeout(run,900);setTimeout(run,2200);
document.addEventListener('n1cmp:render',function(){setTimeout(run,60)});
})();
